import Image from 'next/image';
import React from 'react';

import branchesIcon from '@/assets/images/why-one-branches-icon.svg';
import customerIcon from '@/assets/images/why-one-customers-icon.svg';
import legacyIcon from '@/assets/images/why-one-legacy-icon.svg';

const WhyOneMuthoot = () => {
  return (
    <section className="bg bg-whyOne font-helvetica-neue">
      <div className="container">
        <div className="why-one-parent-container">
          <div className="why-one-flex-prop why-one-text-container">
            <h2 className="text--black text--bold  heading-Onem">
              Why Muthoot FinCorp ONE
            </h2>
            <p className="text--black text--regular para-why-one">
              Muthoot FinCorp ONE comes with the Muthoot Pappachan Group&apos;s
              (Muthoot Blue) trademark trust and customer service, powered by
              our team of dedicated finance experts always willing to serve you.
            </p>
          </div>
          <div className="why-one-cards-cotainer">
            <div className="why-one-flex-prop why-one-card why-one-card-bg1">
              <Image
                style={{ color: undefined }}
                src={legacyIcon}
                alt="legacy"
              ></Image>
              <p className="text--regular why-one-card-text">
                <span className="text--bold">135 years+</span> <br /> of legacy
              </p>
            </div>
            <div className="why-one-flex-prop why-one-card why-one-card-bg2">
              <Image
                style={{ color: undefined }}
                src={customerIcon}
                alt="legacy"
              ></Image>
              <p className="text--regular why-one-card-text">
                Trust of over <span className="text--bold">1 Cr.</span> <br />
                customers
              </p>
            </div>
            <div className="why-one-flex-prop why-one-card why-one-card-bg3">
              <Image
                style={{ color: undefined }}
                src={branchesIcon}
                alt="legacy"
              ></Image>
              <p className="text--regular why-one-card-text">
                <span className="text--bold">3700+ branches</span> <br />
                across India
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyOneMuthoot;
